import React from 'react';
import history from '../../../utils/history';
import { connect } from 'react-redux';
import * as actions from "../../../store/actions";
import { toQueryString } from "../../../utils/uriHelper";

import {
    EstateSearchOverlay,
    EstateSearchFilter,
    EstateSearchResults,
} from '/components/estate-search/components';

class InternalEstateSearch extends React.Component {
    setFilterValue = async (name, value) => {
        let filterValues = {
            categories: [...this.props.filterValues.categories],
            locations: [...this.props.filterValues.locations],
            priceClasses: [...this.props.filterValues.priceClasses]
        };

        if (!this.props.filterValues[name].includes(value)) {
            filterValues[name] = filterValues[name].concat(value);
        } else {
            filterValues[name] = filterValues[name].filter( item => `${item}` !== `${value}` );
        }

        this.redirect(filterValues);
    };

    redirect = filterValues => {
        history.push(`${history.location.pathname}${toQueryString(filterValues)}`);
    };

    componentDidMount = () => {
        this.props.requestData();
    };

    search = event => {
        event.preventDefault();
        const query = this.props.searchTerm;

        if (query.length > 0)
            this.props.search(query);
    };

    clearFilter = () => {
        history.push(history.location.pathname);
        this.resetSearch();
    };

    handleUpdate = event => {
        this.props.setSearchTerm(event.target.value);
    };

    resetSearch = () => {
        this.props.resetSearch();
    };

    render = () => {
        if (!this.props.loaded) {
            return <h1 style={{ textAlign: "center" }}>De panden worden geladen...</h1>
        } else {
            return (
                <div className="estate-search">
                    { this.props.searchLoading && <EstateSearchOverlay /> }
                    <div className="estate-search__header">
                        <div className="estate-search__search">
                            <div className="ais-searchBox">
                            <form noValidate="" className="ais-SearchBox-form" action="" onSubmit={ event => this.search(event) } role="search">
                                <div className="ais-SearchBox__container">
                                    <input
                                        type="search"
                                        placeholder={window.estateOverview.copy.searchField}
                                        autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false"
                                        required=""
                                        maxLength="512"
                                        className="ais-SearchBox-input"
                                        onChange={ event => this.handleUpdate(event) }
                                        value={ this.props.searchTerm }
                                    />
                                    <button
                                        className="ais-SearchBox-submit button is-orange font-supplementary--bold"
                                        type="submit"
                                        title="Zoeken"
                                    >
                                        Zoek
                                    </button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                    <div className="estate-search__filters">
                        <EstateSearchFilter
                            label={window.estateOverview.copy.categories.label}
                            singular={window.estateOverview.copy.categories.singular}
                            plural={window.estateOverview.copy.categories.plural}
                            attribute="categories"
                            clickHandler={this.setFilterValue}
                        />
                        <EstateSearchFilter
                            label={window.estateOverview.copy.locations.label}
                            singular={window.estateOverview.copy.locations.singular}
                            plural={window.estateOverview.copy.locations.plural}
                            attribute="locations"
                            clickHandler={this.setFilterValue}
                        />
                        <EstateSearchFilter
                            label={window.estateOverview.copy.priceClasses.label}
                            singular={window.estateOverview.copy.priceClasses.singular}
                            plural={window.estateOverview.copy.priceClasses.plural}
                            attribute="priceClasses"
                            clickHandler={this.setFilterValue}
                        />
                    </div>
                    <div className="estate-search__empty-filters">
                        <button
                            className="estate-search__empty-filters__button"
                            onClick={() => this.clearFilter()}
                        >
                            Maak filter leeg
                        </button>
                    </div>
                    <EstateSearchResults />
                </div>
            );
        }
    };
}

const mapStateToProps = state => {
    return {
        loaded: state.categories.loaded,
        searchLoading: state.filterValues.loading,
        filterValues: state.filterValues,
        searchTerm: state.filterValues.searchTerm
    };
};

const mapDispatchToProps = dispatch => {
    return {
        requestData: () => dispatch(actions.requestData()),
        search: term => dispatch(actions.search(term)),
        resetSearch: () => dispatch(actions.resetSearch()),
        setSearchTerm: searchTerm => dispatch(actions.setSearchTerm(searchTerm))
    };
}

const EstateSearch = connect(mapStateToProps, mapDispatchToProps)(InternalEstateSearch);

export { EstateSearch };
